import { Dialog, Grid, Typography } from '@material-ui/core';
import { VFC } from 'react';

export type Props = {
  message: string;
};

export const DailyReportForWorkersMessageView: VFC<Props> = props => {
  const { message } = props;

  return (
    <Dialog
      aria-labelledby='transition-modal-title'
      aria-describedby='transition-modal-description'
      open={true}
      maxWidth={'sm'}
      fullWidth={true}
    >
      <Grid container>
        <Grid item xs={12} style={{ padding: 36, textAlign: 'center' }}>
          <Typography variant='subtitle2' align='center'>
            {message}
          </Typography>
        </Grid>
      </Grid>
    </Dialog>
  );
};
